"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySourceDoc = void 0;
const Key_1 = require("./Key");
const util_1 = require("./util");
class KeySourceDoc {
    constructor(opts) {
        this.filter = (0, util_1.resolveFilter)(opts?.filter);
    }
    bind(sink) {
        const filter = this.filter;
        const onKeyDown = (event) => {
            if (filter && !filter(event))
                return;
            const key = Key_1.Key.fromEvent(event);
            sink.onPress(key);
        };
        const onKeyUp = (event) => {
            if (filter && !filter(event))
                return;
            const key = Key_1.Key.fromEvent(event);
            sink.onRelease(key);
        };
        const onReset = () => {
            sink.onReset();
        };
        const doc = typeof document !== 'undefined' ? document : void 0;
        const wnd = typeof window !== 'undefined' ? window : void 0;
        doc?.addEventListener('keydown', onKeyDown);
        doc?.addEventListener('keyup', onKeyUp);
        doc?.addEventListener('compositionstart', onReset);
        doc?.addEventListener('compositionend', onReset);
        doc?.addEventListener('fullscreenchange', onReset);
        wnd?.addEventListener('focus', onReset);
        wnd?.addEventListener('blur', onReset);
        return () => {
            doc?.removeEventListener('keydown', onKeyDown);
            doc?.removeEventListener('keyup', onKeyUp);
            doc?.removeEventListener('compositionstart', onReset);
            doc?.removeEventListener('compositionend', onReset);
            doc?.removeEventListener('fullscreenchange', onReset);
            wnd?.removeEventListener('focus', onReset);
            wnd?.removeEventListener('blur', onReset);
        };
    }
}
exports.KeySourceDoc = KeySourceDoc;
